import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-next",
  "use": "icon-next-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-next\">\r\n      <path d=\"M670.08 112.32v133.76H432.192a340.928 340.928 0 0 0-340.928 335.36v5.632a340.928 340.928 0 0 0 335.296 340.864l5.632 0.064h324.48a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16h-324.48a244.928 244.928 0 0 1-5.12-489.856h477.952a16 16 0 0 0 11.2-27.52l-219.008-213.76a16 16 0 0 0-27.136 11.456z\" p-id=\"15997\" />\r\n    </symbol>"
});
var result = sprite.add(symbol);
export default symbol